<template>
	<div>
		<ihead :checkindex="checkindex"></ihead>
		<div class="banner-box">
			<h1>{{title}}</h1>
		</div>
		<mu-container>
			<mu-breadcrumbs>
				<mu-breadcrumbs-item
					v-for="(item, index) in items"
					:key="index"
					:to="item.to"
					:disabled="item.disabled"
					>{{ item.text }}</mu-breadcrumbs-item
				>
			</mu-breadcrumbs>
		</mu-container>
		<div class="warp lab">
			<div class="lab-contain" style="position:relative;">		
				<swiper :options="swiperOption" ref="myBotSwiper" class="">
				<swiper-slide  v-for="(item,index) in labList" :key=" index + '^-^'" class="swiper-no-swiping">
					<ul>
						<li>			
							<div class="lab-img"><img :src="item.picture.path" alt=""></div>
							<h3 class="lab-name">{{item.name}}</h3>
							<div class="lab-tit">{{item.synopsis}}</div>
							<span class="lab-link" :lang='item.id'>查看详情</span>							
						</li>
					</ul>
					</swiper-slide>
				</swiper>
				<!-- 左右箭头 --> 
				<div class="swiper-button-prev" slot="button-prev" @click="prev()"></div> 
				<div class="swiper-button-next" slot="button-next" @click="next()"></div> 							
			</div>			
			<div class="clearfix"></div>
			<div class="lab-details" v-html="detailsList"></div>
		</div>       
		<div class="clearfix"></div>
		<ifoot></ifoot>
		<returntop class="return-top"></returntop>
	</div>
</template>

<script>
import '../assets/css/lab.css'
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import crumbs from "@/components/crumbs.vue"
import returntop from '@/components/returntop'
export default {
	components: {
			ihead,ifoot,crumbs,returntop
	},
	data () {
		return {
			title: '',
			mainid: this.$route.query.mainid,
      		subid: this.$route.query.subid,
			checkindex:4,
			items: [
				{
				text: "首页",
				to: "/",
				disabled: false
				},
				{
				text: "",
				disabled: true
				},
				{
				text: "",
				disabled: true
				}
			],
			banners: [{
				id: 1,
				img: './static/kenburn-1.jpg',
				link: '#'
			}, {
				id: 2,
				img: '../../static/kenburn-2.jpg',
				link: '#'
			}, {
				id: 3,
				img: '../../static/kenburn-3.jpg',
				link: '#'
			}], 
			swiperOption:{
				//设置点击箭头	
				navigation: {
					nextEl: '.swiper-button-next', 
					prevEl: '.swiper-button-prev'
				},
				//自动轮播
				autoplay: {
					delay: 3000,
					//当用户滑动图片后继续自动轮播
					disableOnInteraction: false,
				},
				//开启循环模式
				loop: true,	
				slidesPerView:3,
				noSwiping : false,
				on:{
					click: (e)=>{
						let swiper = this.$refs.myBotSwiper.$swiper;
						swiper.autoplay.stop()						
						let selectId = e.target.lang;
						for(var i = 0;i<this.labList.length;i++){
							if(this.labList[i].id == selectId){
								this.detailsList = this.labList[i].content
							}
						}
					}
				}
			},
			labList:[],
			detailsList:''
		}
	},
	watch:{
		aa: a=>{
			this.a.methods.isMobile();
		}
	},
	created:function(){
		this.getLabList(1,10)
		this.getNav()	
		this.isMobile()	
	},
	computed:{	
		 myBotSwiper() {
			return this.$refs.myBotSwiper.$swiper
		},		
	},	
	methods: {
		// 判断是手机端 还是 PC 端
		isMobile() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)		
			if(flag){			
				this.swiperOption.slidesPerView = 1		
				// console.log('mobile')
			}else{				
				this.swiperOption.slidesPerView = 3				
				// console.log('pc')
			}
		},


		prev(){
			this.myBotSwiper.autoplay.start()
		},
		next(){
			this.myBotSwiper.autoplay.start()
		},
		getLabList(page,offset){
			this.$get('/laboratory/get-laboratory-list-all',{page:page,offset:offset}).then(res => {
				if(res.code == 0){
					var data = res.data;
					this.labList = data;
					this.detailsList = data[0].content
				}else{
					// console.log(res.message)
				}
			})
		},
		getNav() {
      this.$get("/nav/get-nav-tree").then(res => {
        if (res.code === 0) {
          let data = res.data
          if (data) {
            let newData = data.filter((item, index, array) => {
              return item.id === this.mainid
            })
            this.$set(this.items[1], "text", newData[0].text)
            if (newData[0].children) {
              let subData = newData[0].children
              let newSubData = subData.filter((item, index, array) => {
                return item.id === this.subid
              });
              this.$set(this.items[2], "text", newSubData[0].text)
              this.title = newSubData[0].text
            }
          }
        } else {
        //   console.log(res.message)
        }
      })
    }
	},
}
</script>
<style>
@media screen and ( max-width: 768px){
	.swiper-button-prev,.swiper-button-next{
		display: none;		
	}
	.lab-details{
		margin: 50px 15px;
	}
	.lab-details img{
		width: 100%;
	}
	.lab-details p span strong{
		font-size: 14px;
	}
}
@media screen and ( max-width: 320px) {			
}
</style>
